import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { InfinitySpin } from "react-loader-spinner";

const getData = async (url) => {
  return [
    {
      name: "Edward King",
      accountName: "16",
      accountId: "12422432",
      subscriptionType: "Professional",
      accountManager: "Joe Black",
      customerSince: "Mar, 2022",
      status: "Active",
    },
    {
      name: "Ankush Gupta",
      accountName: "LogZero",
      accountId: "12422432",
      subscriptionType: "Professional",
      accountManager: "Ravi Rose",
      customerSince: "Mar, 2022",
      status: "Active",
    },
    {
      name: "Jim Green",
      accountName: "27",
      accountId: "12422432",
      subscriptionType: "Professional",
      accountManager: "Ankush Gupta",
      customerSince: "Mar, 2022",
      status: "In-Active",
    },
    {
      name: "Joe Black",
      accountName: "31",
      accountId: "12422432",
      subscriptionType: "Professional",
      accountManager: "Edward King",
      customerSince: "Mar, 2022",
      status: "Dormant",
    },
  ];
};

const getFile = async (url) => {
  return new Blob(["example csv content"], { type: "text/csv" });
};

const SuperAdmin = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullwidthwrapper, setFullwidthWrapper] = useState("");
  const [customerList, setCustomerList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullwidthWrapper(isActivated ? "fullwrapper" : "");
  };

  const fetchCustomers = async () => {
    let result = await getData("users/manage-customer-list");
    setCustomerList(result);
    setIsLoading(false);
  };

  useEffect(() => {
    if (searchTerm.trim() === "") {
      fetchCustomers();
    }
  }, [searchTerm]);

  const fillCustomers = () => {
    return customerList.map((customer, index) => (
      <tr key={index}>
        <td>{customer.name}</td>
        <td>{customer.accountName}</td>
        <td>{customer.accountId}</td>
        <td>{customer.subscriptionType}</td>
        <td>{customer.accountManager}</td>
        <td>{customer.customerSince}</td>
        <td>
          <span
            className={`rounded-pill px-2 py-1 fs-12 ${
              customer.status === "Active"
                ? "bg-success-subtle text-teal"
                : customer.status === "In-Active"
                ? "bg-danger-subtle text-danger"
                : "bg-warning-subtle text-warning"
            }`}
          >
            {customer.status}
          </span>
        </td>
        <td className="fs-16">
          <Link to="/ebasic-detail">
            <i className="bi bi-eye mx-1"></i>
          </Link>
          <Link to="/setting">
            <i className="bi bi-gear mx-1"></i>
          </Link>
        </td>
      </tr>
    ));
  };

  const handleExportCsv = async () => {
    try {
      const response = await getFile("users/export-customer-list");
      const url = window.URL.createObjectURL(response);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Customer_Details.csv");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error exporting CSV:", error);
    }
  };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        {/* <Header handleToggle={handleToggle} searchTerm={searchTerm} setSearchTerm={setSearchTerm} /> */}
        <Header onclick={handleToggle} />

        <div className="container-fluid py-3">
          <div className="row">
            <div className="col-lg-7">
              <div className="card border-light-subtle">
                <ul className="nav nav-pills custom-nav-pills custom-background custom-navbar-height">
                  <li className="nav-item">
                    <a className="nav-link active" aria-current="page" href="#">
                      Survey Form
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      Questions
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      Quota
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link ">Field Work</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link ">Survey Data</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link ">Stats</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link ">Analysis</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link ">Reports</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/">
                  <i className="bi bi-people"></i> SuperAdmin
                </Link>
              </li>
            </ul>
          </div>
          <div className="card p-3 border-light-subtle">
            <div className="filter_header fs-12 lh-14">
              <div className="row">
                <div className="col-lg-6">
                  <div className="d-flex gap-1">
                    <div className="search_box">
                      <input
                        type="text"
                        value={searchTerm}
                        className="w-100 form-control"
                        placeholder="Search Customers"
                        onChange={(event) => setSearchTerm(event.target.value)}
                      />
                    </div>
                    <div className="search_button">
                      <button className="btn btn-outline-light border text-dark py-0 fs-12 fw-600" onClick={() => fetchCustomers()}>
                        <i className="bi bi-funnel"></i> Filter
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="d-flex gap-2 justify-content-end mt-3 mt-lg-0">
                    <button className="btn btn-outline-light border text-dark py-0 fs-12 fw-600" onClick={() => handleExportCsv()}>
                      <i className="bi bi-file-earmark-arrow-down fs-14"></i> Export as CSV
                    </button>

                    <button className="btn btn-success py-0 fs-12 fw-600">
                      <i className="bi bi-plus fs-15"></i> Add new customer
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive mt-3">
              <table className="table fs-14 lh-20">
                <thead className="table-light fs-12 lh-16 border-top">
                  <tr>
                    <th>NAME</th>
                    <th>Account name</th>
                    <th>Account ID</th>
                    <th>Subscription Type</th>
                    <th>Account Manager</th>
                    <th>Customer Since</th>
                    <th>Customer Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading && (
                    <tr>
                      <td colSpan={8} className="text-center">
                        <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
                      </td>
                    </tr>
                  )}
                  {fillCustomers()}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdmin;
